import {
  AppBar,
  Avatar,
  Box,
  Button,
  Grid,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useReducer } from 'react';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import routes from '../../../../Utils/routes.json';

import { makeStyles } from '@material-ui/styles';

import EditOutlined from '@material-ui/icons/EditOutlined';
import { useState } from 'react';
import KenCard from '../../../../global_components/KenCard';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
// Icons
import EditIcon from '@material-ui/icons/EditOutlined';
import DoneIcon from '@material-ui/icons/DoneAllTwoTone';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import SchoolIcon from '@material-ui/icons/School';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import moment from 'moment';
import KenGridEditable from '../../../../global_components/kenEditDataGrid/KenGridEcditableForStudentStatus';
import '../../../../style/index.css';
import {
  getAnswer,
  getEvaluation_s2_Data,
  getInviligilation,
  getRevalData,
  getRevalStudentList,
  postRetestData,
  postRevalStudentList,
} from '../../../../Utils/apiServices';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KenButton from '../../../../global_components/KenButton';
import '../../../../style/index.css';
import KenLoader from '../../../../Components/KenLoader';
import SamplePdf from '../../../../Assets/samplePdf.pdf';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useTranslation } from 'react-i18next';
import KenSmallLoader from '../../../../global_components/KenSmallLoader';
import { useHistory, useLocation } from 'react-router-dom';

export const facultyDropDown = [
  { title: 'Jane Coper', year: 1994 },
  { title: 'Wade warren', year: 1972 },
  { title: 'Jane Coper', year: 1974 },
  { title: 'Wade warren', year: 2008 },
  { title: 'Wade warren', year: 1957 },
];

const onToggleEditMode = (id) => {};
const ActionCellEdit = (row, isUpdating) => {
  const { id } = row.row.values;
  return <EditOutlined className="m-0" onClick={() => onToggleEditMode(id)} />;
};

const useStyles = makeStyles((theme) => ({
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    height: '55px',
    marginTop: '25px',
  },
  header1: {
    background: 'transparent',
    color: theme.palette.KenColors.primary,
  },
  TitleBox: {
    display: 'flex',
    float: 'left',
    margin: '25px 10px',
    padding: '10px',
    background: '#fff',
  },
  TitleTextSpan: {
    fontSize: '16px',
    fontWeight: 'bolder',
    marginLeft: '10px',
  },
  TitleText: {
    fontSize: '10px',
    paddingLeft: '10px',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    width: '200px',
  },
  titleCount: {
    color: '#F14B2D',
    fontSize: 12,
  },
  titleCountSpan: {
    color: '#F14B2D',
    fontSize: 12,
    fontWeight: 'bold',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    height: '28px',
    width: '78px',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    background: 'orange',
    borderRadius: '25px',
    fontSize: '10px',
    margin: '5px  5px',
    color: 'white',
    '&:hover': {
      color: 'white',
      background: 'orange',
    },
    // color: '#FFFFFF',
    // background: '#EB5757',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  normal: {
    color: 'white',

    background: '#55b0cd',

    borderRadius: '20px',
    fontSize: '10px',
    height: '25px',
    margin: '5px 5px',
    '&:hover': {
      background: '#55b0cd',

      color: 'white',
    },
    // color: '#FFFFFF',
    // background: '#27AE60',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  publishGenerate: {
    color: '#FFFFFF',
    background: 'green',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  publishView: {
    color: '#FFFFFF',
    background: '#55b0cd',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Blue: {
    color: '#FFFF',
    background: '#03248F',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Green: {
    color: '#FFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  medium: {
    color: '#FFFFFF',
    background: '#F2994A',
    width: '102px',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));

const Revulation = (props) => {
  const { t } = useTranslation();
  const [previous, setPrevious] = useState({});
  const [revFacultyList, setRevFacultyList] = useState([]);
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const propData = history?.location?.state;
  const onToggleEditMode = (check, id, index) => {
    let filterData = {
      id: location.pathname.split('/')[4],
    };

    getEvaluation_s2_Data(filterData)
      .then((res) => {
        const data = res?.data.map((item) => {
          return {
            label: item?.facultyName,
            value: item?.facultyId,
          };
        });

        setRevFacultyList(data);
      })
      .catch((err) => {
        console.log('errr', err);
      });

    const newData = [...rows];
    setRows((state) => {
      return newData.map((row) => {
        console.log('rowrowrowrowrowrow', row);
        if (row.id === id) {
          if (check === 'done') {
            row.isEditMode = true;
            const payload = [
              {
                id: row.id,
                RevalutionStatus: row.status,
                // revalDueDate: row.revaluation_due_date,
                EvaluatorAssignedID: row.EvaluatorAssigedId,
                RevalAccept: row.revalAccept,
                // examDate: row.exam_date,
                // ReasonForRevaluation: row.reason,
              },
            ];

            postRevalStudentList(location.pathname.split('/')[4], payload)
              .then((res) => {
                if (res.success === 'true' || true) {
                  // alert(res.message);
                  row.isEditMode = false;
                  getRevalExamDetailsDataListing();
                }
                row.isEditMode = false;
              })
              .catch((err) => {
                console.log('Failed to add. Please try again.', err);
                row.isEditMode = false;
              });
          }
          if (check === 'edit') {
            return { ...row, isEditMode: !row.isEditMode };
          }
        }
        return row;
      });
    });
  };

  const onChange = (e, row) => {
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rows?.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };

  const onToggleEdit = (id, rowes) => {
    setRows((state) => {
      return rowes.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  const onRevert = (id) => {
    const newRows = rows?.map((row) => {
      if (row.id === id) {
        return previous[id] ? previous[id] : row;
      }
      return row;
    });
    setRows(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
    onToggleEdit(id, newRows);
  };

  const [rows, setRows] = useState([]);
  const [isResponse, setIsResponse] = useState();

  const selectOptionsAllocated = [
    {
      label: 'Completed',
      value: 'Completed',
    },
    {
      label: 'Pending',
      value: 'Pending',
    },
  ];

  const selectOptionsApprove = [
    {
      label: 'Accept',
      value: 'Accept',
    },
    {
      label: 'Reject',
      value: 'Reject',
    },
  ];

  // Editing
  // const [dataOfTable, setDataOfTable] = useState(data);
  const [loading, setLoading] = React.useState(false);
  const [messageDialog, setMessageDialog] = useState(false);

  function handleMessageDialog() {
    setMessageDialog((prevState) => !prevState);
  }
  const handleClickOnView = () => {
    history.push(`${routes.revaluation}`);
  };

  const getRevalExamDetailsDataListing = () => {
    if (propData) {
      setLoading(true);
      getRevalStudentList(propData?.courseId).then((res) => {
        const RevalStudentList = [];
        res[0]?.StudentList.map((item, index) => {
          return {
            CourseId: item?.CourseId ? item?.CourseId : '',
            studentName: item?.StudentName ? item?.StudentName : '',
            marks: item?.Marks ? item?.Marks : '',
            EvaluatorAssigned: item?.EvaluatorAssigned
              ? item?.EvaluatorAssigned
              : '',
            // reason: item?.ReasonForRevaluation
            //   ? item?.ReasonForRevaluation
            //   : '',
            status: item?.RevalutionStatus ? item?.RevalutionStatus : '',
            revalAccept: item?.RevalAccept ? item?.RevalAccept : '',
            EvaluatorAssigedId: item?.Evluaterid ? item?.Evluaterid : '',
          };
        });
        setRows(RevalStudentList);
        let appData = res[0];
        if (appData) {
          setIsResponse(appData);
        }
        setLoading(false);
      });
    }
  };

  useEffect(() => {
    getRevalExamDetailsDataListing();
  }, []);

  // const [Data, setData] = useState([]);
  // useEffect(() => {
  //   getInviligilation()
  //     .then((res) => {
  //       console.log('resssss', res.data);
  //       setData(res);
  //     })
  //     .catch((err) => console.log('errrrrrrrrrrrrrr', err));
  // }, []);
  const getRetestExamDetailsDataListing = () => {
    setLoading(true);
    getAnswer(location.pathname.split('/')[4]).then((res) => {
      const RetestStudentList =
        res === null
          ? []
          : res?.map((item, index) => {
              return {
                id: item.id ? item.id : '',
                studentName: item.studentName ? item.studentName : '',
                marks: item.previousMarks ? item.previousMarks : '',
                EvaluatorAssigned: item.EvaluatorAssigned
                  ? item.EvaluatorAssigned
                  : '',
                // reason: item.reason ? item.reason : '',
                // status: item.RevalutionStatus ? item.RevalutionStatus : '',
                status: item.status ? item.status : '',
                EvaluatorAssigedId: item.Evluaterid ? item.Evluaterid : '',
              };
            });

      setLoading(false);
      setRows(RetestStudentList);
      setIsResponse(res[0]);
    });
  };

  useEffect(() => {
    getRetestExamDetailsDataListing();
  }, []);
  return (
    <Box>
      {' '}
      {loading && <KenLoader />}
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            Student List
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            {
              <Typography variant="h1" className={classes.titleCount}>
                <span className={classes.titleCountSpan}>Count</span> :{' '}
                {rows?.length}
              </Typography>
            }
          </Grid>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            {/* <Button
                startIcon={<GetAppIcon />}
                variant="contained"
                color="primary"
                style={{ marginRight: '15px' }}
                className={classes.addButton}
              >
                <a
                  href={SamplePdf}
                  style={{ textDecoration: 'none', color: 'white' }}
                  download
                >
                  {t('labels:Report')}
                </a>
              </Button> */}
            <Button
              variant="contained"
              color="primary"
              style={{
                marginRight: '15px',
              }}
              onClick={() => history.goBack()}
              // className={classes.addButton}
            >
              Back
            </Button>
          </Grid>
        </Toolbar>
      </AppBar>
      <AppBar position="static" elevation={0} className={classes.header1}>
        <Grid xs={12} style={{ display: 'flex', float: 'left' }}>
          <Grid item xs={3} className={classes.TitleBox}>
            <Avatar
              sx={{ bgcolor: 'red' }}
              style={{ backgroundColor: 'transparent' }}
              aria-label="recipe"
            >
              <AssignmentIcon style={{ color: '##272727' }} />
            </Avatar>
            <div>
              {' '}
              <div className={classes.TitleTextSpan}>
                {isResponse?.CourseName || isResponse?.courseName}
              </div>
              <div className={classes.TitleText}>COURSE NAME</div>
            </div>
          </Grid>
          <Grid item xs={3} className={classes.TitleBox}>
            <Avatar
              sx={{ bgcolor: 'red' }}
              style={{ backgroundColor: 'transparent' }}
              aria-label="recipe"
            >
              <SchoolIcon style={{ color: '##272727' }} />
            </Avatar>
            <div>
              {' '}
              <div className={classes.TitleTextSpan}>
                {isResponse?.Term || isResponse?.termName}
              </div>
              <div className={classes.TitleText}> TERM </div>
            </div>
          </Grid>
          <Grid item xs={3} className={classes.TitleBox}>
            <Avatar
              sx={{ bgcolor: 'red' }}
              style={{ backgroundColor: 'transparent' }}
              aria-label="recipe"
            >
              <AssignmentIndIcon style={{ color: '##272727' }} />
            </Avatar>
            <div>
              {' '}
              <div className={classes.TitleTextSpan}>
                {isResponse?.ProgrameName || isResponse?.programe}
              </div>
              <div className={classes.TitleText}> Program </div>
            </div>
          </Grid>
          <Grid item xs={3} className={classes.TitleBox}>
            <Avatar
              sx={{ bgcolor: 'red' }}
              style={{ backgroundColor: 'transparent' }}
              aria-label="recipe"
            >
              <AssignmentIndIcon style={{ color: '##272727' }} />
            </Avatar>
            <div>
              {' '}
              <div className={classes.TitleTextSpan}>{isResponse?.Batch} </div>
              <div className={classes.TitleText}> Batch </div>
            </div>
          </Grid>
        </Grid>
      </AppBar>
      <Box className={`cardlsitbox`}>
        <KenCard elevation={0}>
          <Table className={classes.table} aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell className="tableHeaderTitle" align="left">
                  STUDENT NAME
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  MARKS
                </TableCell>
                {/* <TableCell className="tableHeaderTitle" align="left">
                    STUDENT
                  </TableCell> */}
                {/* <TableCell className="tableHeaderTitle" align="left">
                    EVALUATOR ASSIGNED
                  </TableCell>{' '} */}
                {/* <TableCell className="tableHeaderTitle" align="left">
                  REASON
                </TableCell> */}
                {/* <TableCell className="tableHeaderTitle" align="left">
                    REVALUATION STATUS
                  </TableCell> */}
                {/* <TableCell className="tableHeaderTitle" align="left">
                    BATCH
                  </TableCell> */}
                {/* <TableCell className="tableHeaderTitle" align="left">
                    EDIT
                  </TableCell> */}
                <TableCell className="tableHeaderTitle" align="left">
                  Status
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="tablebody1">
              {rows.length === 0 && (
                <TableCell colSpan={7}>No Record</TableCell>
              )}
              {rows.map((row) => {
                const SetDateFormat = {
                  ...row,
                  examDate: moment(row.dateTimeofExam).format(
                    'YYYY-MM-DD HH:mm'
                  ),
                };

                return (
                  <TableRow className="editableTableRowData" key={row.id}>
                    <KenGridEditable
                      {...{
                        row: SetDateFormat,
                        onChange,
                        columns: [
                          {
                            column_name: 'studentName',
                            is_inline_edit: false,
                            // inline_edit_type: 'kenDatePicker',
                            label: '',
                          },
                          {
                            column_name: 'marks',
                            is_inline_edit: false,
                            // inline_edit_type: 'kenDatePicker',
                            label: '',
                          },
                          // {
                          //   column_name: 'EvaluatorAssigned',
                          //   is_inline_edit: true,
                          //   inline_edit_type: 'kenSelect',
                          //   dropdown: revFacultyList,
                          // },
                          // {
                          //   column_name: 'no_of_documents',
                          //   is_inline_edit: true,
                          //   inline_edit_type: 'kenInput',
                          //   dropdown: selectOptionsAllocated,
                          // },

                          // {
                          //   column_name: 'allocatedTo',
                          //   is_inline_edit: true,
                          //   inline_edit_type: 'kenSelect',
                          //   dropdown: selectOptionsAllocated,
                          //   label: 'allocatedTo',
                          //   onChange: handleSelectChangeAllocated,
                          // },
                          // {
                          //   column_name: 'revaluation_due_date',
                          //   is_inline_edit: true,
                          //   inline_edit_type: 'kenDatePicker',
                          //   label: '',
                          // },

                          //   {
                          //     column_name: 'reason',
                          //     is_inline_edit: false,
                          //     inline_edit_type: '',
                          //   },
                          {
                            column_name: 'status',
                            is_inline_edit: true,
                            inline_edit_type: 'kenSelect',
                            dropdown: selectOptionsApprove,
                            // label: 'eligibility_status',
                            // style: 'red',
                          },
                        ],
                      }}
                    />
                    <TableCell className={classes.selectTableCell}>
                      {row.isEditMode ? (
                        <>
                          <IconButton
                            aria-label="done"
                            onClick={() => onToggleEditMode('done', row.id)}
                          >
                            <DoneIcon />
                          </IconButton>
                          <IconButton
                            aria-label="revert"
                            onClick={() => onRevert(row.id)}
                          >
                            <RevertIcon />
                          </IconButton>
                        </>
                      ) : (
                        <IconButton
                          aria-label="delete"
                          onClick={() => onToggleEditMode('edit', row.id)}
                        >
                          <EditIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </KenCard>
      </Box>
    </Box>
  );
};

export default Revulation;
